import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-016424c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forecasting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-2xl" }, "Вы действительно хотите удалить?"),
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium mt-4" }, " После удаления Волны вы не сможете восстановить его обратно ")
], -1))
const _hoisted_3 = { class: "mt-8 grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "bg-white rounded px-4 py-3 flex items-center justify-between mt-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold uppercase" }, "Волны прибытия", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_7 = {
  key: 2,
  class: "mt-2 p-4 bg-white rounded text-sm text-gray-400 select-none flex flex-col items-center justify-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Загрузка списка волн...", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка волн произошла ошибка", -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 3,
  class: "ForecastingWaves"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_wave_invoice_panel_information = _resolveComponent("wave-invoice-panel-information")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_forecasting_delivery = _resolveComponent("forecasting-delivery")!
  const _component_forecasting_planning = _resolveComponent("forecasting-planning")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_forecasting_wave = _resolveComponent("forecasting-wave")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.delete_state.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Удаление волны",
          "confirm-button-text": "Удалить",
          "confirm-button-class": "NewButton--danger",
          loading: _ctx.delete_state.is_loading,
          onSubmit: _ctx.deleteWave,
          onCancel: _ctx.cancelDelete
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.invoice_panel.is_opened)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 1,
          title: "Информация",
          "without-footer": "",
          onCancel: _ctx.closeInvoicePanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_wave_invoice_panel_information, {
              invoice: _ctx.invoice_panel.invoice,
              "is-update-loading": _ctx.invoice_panel.is_loading,
              onCancel: _ctx.closeInvoicePanel,
              onUpdate: _ctx.updateInvoice
            }, null, 8, ["invoice", "is-update-loading", "onCancel", "onUpdate"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Прогнозирование" }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_forecasting_delivery, {
        "dispatcher-sector-ids": _ctx.new_dispatcher_store.dispatcherSectorIds
      }, null, 8, ["dispatcher-sector-ids"]),
      _createVNode(_component_forecasting_planning, {
        "dispatcher-sector-ids": _ctx.new_dispatcher_store.dispatcherSectorIds
      }, null, 8, ["dispatcher-sector-ids"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_router_link, { to: "/new-dispatcher/waves/create" }, {
        default: _withCtx(() => [
          _createVNode(_component_new_button, null, {
            "icon-left": _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Добавить ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.waves.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_8
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_9,
                  _createVNode(_component_new_button, {
                    class: "NewButton--outline mt-1",
                    onClick: _ctx.loadWaves
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Обновить")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (_ctx.state.waves.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Список волн пуст"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.waves, (wave) => {
            return (_openBlock(), _createBlock(_component_forecasting_wave, {
              key: wave.id,
              wave: wave,
              "dispatcher-sector-ids": _ctx.new_dispatcher_store.dispatcherSectorIds,
              onShowInvoice: _ctx.openInvoicePanel,
              onUpdateWave: _ctx.onWaveUpdate,
              onDeleteWave: _ctx.startDelete
            }, null, 8, ["wave", "dispatcher-sector-ids", "onShowInvoice", "onUpdateWave", "onDeleteWave"]))
          }), 128))
        ]))
  ]))
}